module.exports = __webpack_public_path__ + "img/circle_point.5634053d.png";